'use strict';


import { DoubleSide, MathUtils, Matrix4, MeshBasicMaterial, Object3D, Quaternion, Spherical, Vector3 } from 'three';
import { Text } from '../../components/preloader/DreamsSlider/Text/Troika';
import { getCurrentLang } from '../../components/langSwitcher/langSwitcher';
import { threeJsVariables } from '../../../settings';

const spherical = new Spherical();
const direction = new Vector3();
const cameraDirection = new Vector3();
const target = new Vector3();
const matrix = new Matrix4();
const quaternion = new Quaternion();

let angle = 0;
let phi = 0;
let theta = 0;
let _phiAngle = 0;
let distance = 0;

export class Text3D extends Object3D{

  constructor (data) {
    super();

    this.position.fromArray(data.position);
    this.rotation.fromArray(data.rotation);
    this.scale.fromArray(data.scale);
    this.name = data.id;
    this.objectType = 'Text';

    this.translations = data.translations;
    this.rotations = data.rotations;
    this.hideDistance = data.hideDistance || 0;
    this.update = true;

    this.text = new Text();
    this.text.material = new MeshBasicMaterial({ side: DoubleSide});
    this.text.font = './fonts/assistant/Assistant-Regular.woff';
    Object.entries(data.options).forEach(([key,value]) => {
      if (value === null) {
        value = Infinity;
      }
      this.text[key] = value;
    });

    this.translateText();
    this.add(this.text);
    threeJsVariables.composer.addUpdatableElement(this);
  }

  translateText() {
    let translate = this.translations[getCurrentLang()];
    if (!translate) {
      translate = Object.values(this.translations)[0] || 'Default text';
    }
    this.text.text = translate;
    this.text.sync();
  }

  tick() {
    if (!this.update)
      return;

    if (this.hideDistance > 0) {
      distance = threeJsVariables.perspectiveCamera.position.distanceTo(this.position);
      if (distance > this.hideDistance) {
        this.visible = false;
        return;
      } else {
        this.visible = true;
      }
    } else {
      this.visible = true;
    }

    if (this.rotations.autoRotate) {
      phi = threeJsVariables.orbitControls.getPolarAngle();
      theta = threeJsVariables.orbitControls.getAzimuthalAngle();
      this.text.getWorldDirection(direction);
      spherical.setFromVector3(direction);

      if (this.rotations.longitude) {
        spherical.phi = phi;

        if (this.rotations.flip) {
          threeJsVariables.perspectiveCamera.getWorldDirection(cameraDirection);
          cameraDirection.setY(0);
          direction.setY(0);
          angle = MathUtils.radToDeg(direction.angleTo(cameraDirection));
          if (angle < 90) {
            spherical.theta = Math.PI + spherical.theta;
          }
        }
      }

      if (this.rotations.latitude) {
        spherical.theta = theta;
      }

      if (this.rotations.hide && (this.rotations.longitude || this.rotations.latitude)) {
        threeJsVariables.perspectiveCamera.getWorldDirection(cameraDirection);

        if (this.rotations.longitude && !this.rotations.latitude) {
          cameraDirection.setY(0);
          direction.setY(0);
          angle = MathUtils.radToDeg(direction.angleTo(cameraDirection));
          _phiAngle = MathUtils.radToDeg(Math.abs(phi));
          this.visible = !(angle > 70 && angle < 120 && (_phiAngle > 30 && _phiAngle < 120));
        }

        if (this.rotations.latitude && !this.rotations.longitude) {
          angle = MathUtils.radToDeg(direction.angleTo(cameraDirection));
          this.visible = angle >= 120;
        }

      } else if (!this.visible) {
        this.visible = true;
      }

      target.setFromSpherical(spherical);
      matrix.lookAt(target,this.text.position,this.text.up);
      this.text.quaternion.setFromRotationMatrix(matrix);
      matrix.extractRotation(this.matrixWorld);
      quaternion.setFromRotationMatrix(matrix);
      this.text.quaternion.premultiply(quaternion.invert());
    }
  }

  visibilityToggle(state) {
    if (state) {
      this.visible = true;
      this.update = true;
    } else {
      this.update = false;
      this.visible = false;
    }
  }

}
